module.exports = __webpack_public_path__ + "static/media/squared-arrow.d0b1f8db.svg";